@use '../../sass/theme';
.badge {
  align-items: center;
  background-color: var(--jui-badge-color-bg);
  color: var(--jui-badge-color-contrast);
  display: inline-flex;
  flex: none;
  flex-direction: row;
  font-size: var(--jui-badge-fs);
  font-weight: 500;
  justify-content: center;
  position: relative;
  padding: var(--jds-space-inset-xxs);
  font-family: var(--jui-font-family);
  line-height: 17px;
  user-select: none;
  white-space: nowrap;
  z-index: 5;

  &__content {
    transform: scale(1);
  }
}

$variants: primary, secondary, success, info, warning, danger, low, high;

@mixin get-variants() {
  @each $variant in $variants {
    .badge--#{$variant} {
      --jui-badge-color-bg: var(--jui-#{$variant}-color);
      --jui-badge-color-contrast: var(--jui-#{$variant}-color--contrast);
    }
  }
}

@include get-variants;

.badge--count {
  border-radius: 40px;
  min-height: 17px;
  min-width: 17px;
  padding: 3px;

  &-sm {
    min-height: unset;
    min-width: unset;
    height: 10px;
    width: 10px;
  }
}

.badge--label {
  border-radius: var(--jui-btn-border-radius);
  line-height: 1.7;
  padding: 0 8px;
}

.badge--marker {
  border-radius: 100%;
  width: 8px;
  height: 8px;
}

.badge--outlined {
  box-shadow: 0 0 0 1px currentColor;
}

.badge--topLeft {
  left: 0;
  position: absolute;
  top: 0;
  transform: translate(-50%, -50%);

  &-sm {
    top: 2px;
  }
}

.badge--topRight {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -50%);

  &-sm {
    top: 2px;
  }
}

.badge--bottomLeft {
  bottom: 0;
  left: 0;
  position: absolute;
  transform: translate(-50%, 50%);

  &-sm {
    bottom: 2px;
  }
}

.badge--bottomRight {
  bottom: 0;
  position: absolute;
  right: 0;
  transform: translate(50%, 50%);

  &-sm {
    bottom: 2px;
  }
}

@keyframes pulse {
  0% {
    opacity: 0.5;
    transform: scale(1);
  }

  80% {
    transform: scale(1.6);
  }

  100% {
    opacity: 0;
    transform: scale(1.6);
  }
}

@keyframes pulse-marker {
  0% {
    opacity: 0.5;
    transform: scale(1);
  }

  80% {
    transform: scale(2.2);
  }

  100% {
    opacity: 0;
    transform: scale(2.2);
  }
}

@keyframes shakeTopRight {
  0% {
    transform: translate(35%, -50%);
  }
  25% {
    transform: translate(65%, -50%);
  }
  50% {
    transform: translate(35%, -50%);
  }
  75% {
    transform: translate(65%, -50%);
  }
  100% {
    transform: translate(50%, -50%);
  }
}

@keyframes shakeTopLeft {
  0% {
    transform: translate(-35%, -50%);
  }
  25% {
    transform: translate(-65%, -50%);
  }
  50% {
    transform: translate(-35%, -50%);
  }
  75% {
    transform: translate(-65%, -50%);
  }
  100% {
    transform: translate(-50%, -50%);
  }
}

@keyframes shakeBottomRight {
  0% {
    transform: translate(35%, 50%);
  }
  25% {
    transform: translate(65%, 50%);
  }
  50% {
    transform: translate(35%, 50%);
  }
  75% {
    transform: translate(65%, 50%);
  }
  100% {
    transform: translate(50%, 50%);
  }
}

@keyframes shakeBottomLeft {
  0% {
    transform: translate(-35%, 50%);
  }
  25% {
    transform: translate(-65%, 50%);
  }
  50% {
    transform: translate(-35%, 50%);
  }
  75% {
    transform: translate(-65%, 50%);
  }
  100% {
    transform: translate(-50%, 50%);
  }
}

.badge--announce {
  &.badge--topRight {
    animation: shakeTopRight 0.25s forwards ease-in;
  }
  &.badge--topLeft {
    animation: shakeTopLeft 0.25s forwards ease-in;
  }
  &.badge--bottomRight {
    animation: shakeBottomRight 0.25s forwards ease-in;
  }
  &.badge--bottomLeft {
    animation: shakeBottomLeft 0.25s forwards ease-in;
  }
}

.badge--pulsing {
  &:before {
    animation: pulse 1.8s infinite ease-in;
    background-color: var(--jui-badge-color-bg);
    border-radius: inherit;
    bottom: 0;
    content: '';
    flex: none;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transform: scale(1);
  }

  &.badge--marker:before {
    animation: pulse-marker 1.8s infinite ease-in;
  }
}
